import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowLeft, Check } from "@phosphor-icons/react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const ConnectForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/api/connect/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur lors de l'envoi");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <main className="min-h-screen bg-[#EDEBE4] flex items-center justify-center px-6" data-testid="forgot-password-sent">
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="text-center max-w-md">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Check size={32} weight="bold" className="text-green-600" />
          </div>
          <h1 className="font-heading text-2xl text-[#1A1A1A] mb-4">Email envoyé</h1>
          <p className="text-[#1A1A1A]/70 font-light mb-8">
            Si un compte existe avec l'adresse <strong>{email}</strong>, vous recevrez un lien de réinitialisation dans quelques instants. Vérifiez également vos spams.
          </p>
          <Link to="/connect" className="btn-dark inline-flex items-center gap-3" data-testid="back-to-login">
            <ArrowLeft size={16} /> Retour à la connexion
          </Link>
        </motion.div>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-[#EDEBE4] flex items-center justify-center px-6" data-testid="forgot-password-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="text-center mb-10">
          <Link to="/" className="inline-block mb-6">
            <span className="font-heading text-2xl tracking-[0.35em] text-[#1A1A1A] uppercase">Altura</span>
          </Link>
          <h1 className="font-heading text-3xl text-[#1A1A1A] mb-2">Mot de passe oublié</h1>
          <p className="text-[#1A1A1A]/60 text-sm font-light">Entrez votre email pour recevoir un lien de réinitialisation</p>
        </div>

        <div className="bg-white border border-[#1A1A1A]/10 p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-[#1A1A1A]/70 text-xs tracking-wide uppercase block mb-2">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="input-luxury w-full bg-transparent" placeholder="votre@email.com" data-testid="forgot-email-input" />
            </div>
            {error && <p className="text-red-600 text-sm" data-testid="forgot-error">{error}</p>}
            <button type="submit" disabled={loading} className="btn-dark w-full flex items-center justify-center gap-3" data-testid="forgot-submit-btn">
              {loading ? "Envoi..." : "Envoyer le lien"}
              <ArrowRight size={16} weight="bold" />
            </button>
          </form>
        </div>

        <div className="text-center mt-6">
          <Link to="/connect" className="text-[#1A1A1A]/60 text-sm hover:text-[#1A1A1A] transition-colors">
            <ArrowLeft size={14} className="inline mr-1" /> Retour à la connexion
          </Link>
        </div>
      </motion.div>
    </main>
  );
};

export default ConnectForgotPassword;
